import {
  ECHART_TOP,
  ECHART_GRID_HEIGHT,
  ECHART_LEGEND_HEIGHT,
  ECHART_LEGEND_LINE_SPACING,
  ECHART_LEGEND_FIRST_LINE_TOP_SPACING,
  ECHART_LEGEND_TOP,
} from '@/pages/intelligence/pages/Compare/PcConsoleGames/constants/echart';

/**
 * 多行图例，计算每行图例的top值
 * @param option 计算依赖信息
 * @param option.index 当前图例行的索引
 * @param option.itemHeight 每行图例的高度
 * @param option.itemSpacing 每行图例间隔
 * @return 当前图例行的top值
 */
export function calcLegendTopOfMultiLegendMode(option: {
  index: number;
  itemHeight?: number;
  itemSpacing?: number;
}): number {
  const { index, itemHeight = ECHART_LEGEND_HEIGHT, itemSpacing = ECHART_LEGEND_LINE_SPACING } = option;
  if (
    typeof index !== 'number' ||
    Number.isNaN(index) ||
    typeof itemHeight !== 'number' ||
    Number.isNaN(itemHeight) ||
    typeof itemSpacing !== 'number' ||
    Number.isNaN(itemSpacing)
  )
    return ECHART_LEGEND_TOP;

  // echart距离容器的top + echart的grid的高度
  const height1 = ECHART_TOP + ECHART_GRID_HEIGHT;
  // 当前行图例 之前行图例（上方的图例行）的总高度
  const height2 = index * (ECHART_LEGEND_HEIGHT + ECHART_LEGEND_LINE_SPACING);

  return height1 + ECHART_LEGEND_FIRST_LINE_TOP_SPACING + height2;
}
